<template>
  <!-- <div class="container">
    <div class="row">
      <div class="col-md-4" v-html="description">
      </div>
      <div class="col">
        <div class="row" v-for="(question, index) in questions" :key="index">
          <!- - TODO: move question templates to... questions and: <div v-html="question.template"></div> - ->
          <p v-html="question.label"></p>
          <p v-html="question.description"></p>
          <form>
            <p class="hand-written">{{question.variant1}}</p>
            <p>{{question.variant2}}</p>
            <div
              class="form-check form-check-inline"
              v-for="(choice, index) in question.choices"
              :key="index"
            >
              <input class="form-check-input" type="radio" :name="'radio-group-' + question.id" v-model="question.response" :value="choice">
              <label class="form-check-label" for="correct">{{ choice }}</label>
            </div>
          </form>
        </div>
      </div>
  </div> -->
  <div class="container">
    <div class="row">
      <div class="col-md-4" v-html="description"></div>
      <div class="col">
        <div class="row" v-for="question in questions" :key="question.id">
          <div class="col">
            <p v-html="question.label"></p>
            <p v-html="question.description"></p>
            <p class="hand-written">{{ question.variant1 }}</p>
            <p>{{ question.variant2 }}</p>
            <div
              class="form-check form-check-inline"
              v-for="(choice, index) in question.choices"
              :key="question.id * 100 + index"
            >
              <input
                class="form-check-input"
                type="radio"
                :name="'radio-group-' + question.id"
                :id="`choice-${question.id}-${index}`"
                v-on:change="handleInputCompleted"
                v-model="question.response"
                :value="choice"
              />
              <label
                class="form-check-label"
                :for="`choice-${question.id}-${index}`"
              >
                {{ choice }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerifyingDataHorizontal'
}
</script>
